<template>
  <div class="flex md12 xs12">
    <vuestic-widget :headerText="$t('report.reportDownload.MonthlyReport')" id="reportInfo">
      <div class="generate-report">
        <button class="btn btn-info btn-micro btn-download mr-2" @click="generateMonthlyReport">
          <div class="btn-with-icon-content d-flex">
            <span class="ml-1" style="white-space: nowrap;">{{'report.GenerateMonthlyReport' | translate}}</span>
          </div>
        </button>
        <button
          class="btn btn-info btn-micro btn-download"
          @click="refresh"
          style="background-color: #4ae387;"
        >
          <div class="btn-with-icon-content d-flex">
            <span class="ml-1" style="white-space: nowrap;">{{'basic.button.refresh' | translate}}</span>
          </div>
        </button>
      </div>
      <el-table ref="filterTable" :data="tableData" style="width: 100%" :empty-text="$t('tables.dataTable.noDataAvailable')">
        <el-table-column prop="period" :label="$t('report.reportDownload.period')" />
        <el-table-column prop="trans_count" :label="$t('report.reportDownload.transactions')" />
        <el-table-column prop="result" :label="$t('report.reportDownload.result')" />
        <el-table-column prop="report_url" :label="$t('report.reportDownload.actions')">
          <template slot-scope="scope">
            <a
              v-if="scope.row.status === 2 && !!scope.row.report_url"
              :href="scope.row.report_url"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button class="btn btn-info btn-micro btn-download">
                <div class="btn-with-icon-content d-flex">
                  <i class="ion-md-download ion"></i>
                  <span class="ml-1">{{ "basic.button.download" | translate }}</span>
                </div>
              </button>
            </a>
          </template>
        </el-table-column>
      </el-table>
      <div class="block text-center">
        <pagination :total="total" :page.sync="page" :limit.sync="limit" @pagination="drawMonthlyReportSummary" />
      </div>
    </vuestic-widget>

    <vuestic-modal show.sync="true"
                   ref="GenerateModal"
                   :okText="'modal.confirm2' | translate"
                   :okClass="'btn btn-primary btn-micro'"
                   :cancelClass="'btn btn-secondary btn-micro'"
                   :cancelText="'modal.cancel2' | translate"
                   style="width: 60vw;height:100%;"
                   class="generate-modal">
      <div slot="title">{{'report.GenerateMonthlyReport' | translate}}</div>
      <div>
        <form onsubmit="return false">
          <div class="va-row">
            <div class="flex md12">
              <div>{{'tables.statusHisInfo.date' | translate}}</div>
              <el-date-picker
                v-model="monthDate"
                style="width: 100% !important"
                type="month"
                format="yyyy-MM"
                value-format="yyyy-MM"
                :clearable="false"
                default-time="2025-02-02"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </div>
          </div>
        </form>
      </div>
    </vuestic-modal>

		<div class="flex xs12 md6 flex-center" v-if="isToastContent">
			<div class="toasted-container sample-toasted-container shrink">
				<div class="toasted vuestic-toast none default">
					<i class="fa" :class="toastIcon" v-if="toastIcon" />
					{{toastText}}
				</div>
			</div>
		</div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { request } from '@/utils/utils';
let moment = require("moment-timezone");

export default {
  data() {
    return {
      tableData: [],
      total: 0, // 数据总条数
      page: 1, // 默认显示第1页
      limit: 6, // 默认一次显示10条数据
      reportTable: {
        month: '180',
        revenue: '180',
        transactions: '',
        actions: '100'
      },
      monthDate: '',
      pickerOptions: {
        // 禁用今天之后的月份
        disabledDate(time) {
          const currentDate = new Date();
          const currentYear = currentDate.getFullYear();
          const currentMonth = currentDate.getMonth();
          const timeYear = time.getFullYear();
          const timeMonth = time.getMonth();

          return timeYear > currentYear || (timeYear === currentYear && timeMonth > (currentMonth - 1));
        }
      },
      // toast
      isToastContent: false,
      toastIcon: 'fa-star-o',
      toastText: '',
      toastPosition: 'top-center',
      toastDuration: 2500,
      isToastFullWidth: false,
    }
  },
  mounted() {
    if(this.isMobile === 'mobile') {
      this.$set(this.reportTable, 'month', 60);
      this.$set(this.reportTable, 'revenue', 80);
      this.$set(this.reportTable, 'transactions', 240);
      this.$set(this.reportTable, 'actions', 70);
    }
    this.drawMonthlyReportSummary();
  },
  methods: {
    drawMonthlyReportSummary() {
      let token = localStorage.getItem('Authorization');
      let start = this.page;
      let limit = this.limit;
      let url = "api/dashboard/report/list-monthly-report?access_token=" + token
      const today = moment().format('YYYY-MM-DD');
      const oneYearAgo = moment().subtract(1, 'year').format('YYYY-MM-DD');
      this.loadingFullScreen("reportLoading", "Loading", "fa fa-hourglass-half")
      request({
        method: 'post',
        url,
        data: {
          start_time: `${oneYearAgo} 00:00:00`,
          end_time: `${today} 23:59:59`,
          page_num: start,
          page_size: limit
        }
      }).then(res => {
        const { list, total } = res.data.data
        this.tableData = list;
        this.total = total
      }).catch(() => { this.reportLoading.close() });
      this.reportLoading.close()
    },
    revenueFormatter(row, column) {
      return row.currency + " " + row.revenue;
    },
    async generateMonthlyReportImpl() {
      let access_token = localStorage.getItem('Authorization');
      const url = `api/dashboard/report/monthly-report?date=${this.monthDate}`
      this.loadingFullScreen("generateMonthlyLoading", "Loading", "fa fa-hourglass-half")
      const res = await request({
        method: 'POST',
        url: url,
        headers: { access_token }
      }).catch(() => { this.generateMonthlyLoading.close() })
      this.generateMonthlyLoading.close();
      const { code, msg } = res.data
      if (code === '10000') {
        this.$refs.GenerateModal.close()
        this.drawMonthlyReportSummary()
        this.launchToast(msg, 'success')
      } else {
        this.launchToast(msg, 'error')
      }
    },
    generateMonthlyReport() {
      this.$refs.GenerateModal.open()
      // 设置默认月份为上个月
      this.monthDate = moment().subtract(1, 'month').format('YYYY-MM');
      this.$validator.reset()
      this.$refs.GenerateModal.ok = async () => {
        await this.generateMonthlyReportImpl()
      }
      this.$refs.GenerateModal.cancel = () => {
        this.$refs.GenerateModal.close()
      }
    },
    refresh() {
      this.drawMonthlyReportSummary()
    },
    launchToast (message = '', type = 'success') {
      this.toastText = message
      this.toastIcon = type === 'success' ? 'fa-star-o' : 'fa-exclamation-triangle'
      this.isToastContent = true
      this.showToast(message, {
        icon: this.toastIcon,
        position: this.toastPosition,
        duration: this.toastDuration,
        fullWidth: this.isToastFullWidth
      })
      this.isToastContent = false
    },
    loadingFullScreen(controller, txt, className) {
      this[controller] = this.$loading({
        lock: true,
        text: txt,
        spinner: className,
        background: "rgba(0, 0, 0, 0.7)",
      });
    }
  },
  components: {
    Pagination
  }
}
</script>
<style lang="scss">
@import "./Report.scss";
.el-month-table {
  a:not([href]):not([tabindex]) {
    color: unset;
  }
  td.disabled .cell {
    color: #C0C4CC;
  }
}
</style>
<style lang="scss" scoped>
/deep/ .generate-modal {
  .modal-dialog {
    max-width: 1000px;
    .modal-content {
      width: 400px;
      .modal-body {
        margin-bottom: 20px;
      }
    }
  }
  .modal-body {
    padding-bottom: 0;
  }
}
</style>
